<style lang="scss">
.el-popover.my-el-popover {
  position: absolute;
  background: #fff;
  min-width: 150px !important;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  //padding: 12px;
  z-index: 2000;
  color: #606266;
  line-height: 1.4;
  text-align: justify;
  font-size: 14px;
  //-webkit-box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  //box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  word-break: break-all;
}
</style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/quality/inspection/record/details/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('jianyanleixing')">
            <span v-if="$attrs.detailsItem.inspectionType == 1">{{ $t('shoujian') }}</span>
            <span v-if="$attrs.detailsItem.inspectionType == 2">{{ $t('choujian') }}</span>
            <span v-if="$attrs.detailsItem.inspectionType == 3">{{ $t('mojian') }}</span>
            <span v-if="$attrs.detailsItem.inspectionType == 4">{{ $t('chengpinjian') }}</span>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('chanpinbianma/mingcheng')">
            <yi_cross_select disabled :selectTitle="'code,name'" multiple :component="'web_base_matter_list'" :ids.sync="$attrs.detailsItem.materialId"> </yi_cross_select>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('jianyanzhuangtai')">
            <span v-if="$attrs.detailsItem.status == 1">{{ $t('weijianyan') }}</span>
            <span v-if="$attrs.detailsItem.status == 2">{{ $t('jianyanhege') }}</span>
            <span v-if="$attrs.detailsItem.status == 3">{{ $t('jianyanbuhege') }}</span>
            <span v-if="$attrs.detailsItem.status == 4">{{ $t('zuofei') }}</span>
          </el-form-item>
          <el-form-item>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <template #jianyanjieguo="scope">
        <span v-if="scope.row.result == 0">{{ $t('buhege') }}</span>
        <span v-if="scope.row.result == 1">{{ $t('hege') }}</span>
      </template>
      <template #celiangzhi="scope">
        <span v-if="scope.row.inspectionFlag == 2">
          <el-popover placement="bottom" width="105" popper-class="my-el-popover" trigger="click">
            <div v-html="newNumbers(scope.row.measureJson)"></div>
            <el-button slot="reference" type="text"> {{ scope.row.measureJson == null || scope.row.measureJson == '' ? '' : $t('chakan') }}</el-button>
          </el-popover>
        </span>
        <span v-else>
          {{ scope.row.measureJson == null ? '' : scope.row.measureJson + '' }}
        </span>
      </template>
      <template #buliangpinshu="scope">
        <span
          @click="
            yt.showEditDialog('buliangmingxi', scope.row, '80%');
            getDefectTypeAndCode();
          "
          style="color: #419FFF"
          >{{ scope.row.defectQuantity }}</span
        >
      </template>
      <template #jianyanbiaoshi="scope">
        <span v-if="scope.row.inspectionFlag == 1">{{ $t('dingxing') }}</span>
        <span v-if="scope.row.inspectionFlag == 2">{{ $t('dingliang') }}</span>
      </template>
      <template #tupian="scope">
        <yi_upload :readOnly="true" :ids.sync="scope.row.uploadFiles" :limit="5"> </yi_upload>
      </template>
      <template #chouyangguocheng="scope">
        <span v-if="scope.row.inspectionStandardDetail">{{ scope.row.samplingProcedureDTO.code }}/{{ scope.row.samplingProcedureDTO.desc }}</span>
      </template>
    </yi_curd_table>
    <!--不良明细-->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <template v-if="yt.editObj.action == 'buliangmingxi'">
        <div class="dialog-scroller">
          <el-tabs v-model="tabsActive">
            <el-tab-pane v-for="(tops, index) in defectTab" :key="tops.levelOneDefectTypeDesc" :label="tops.levelOneDefectTypeDesc" :name="tops.levelOneDefectTypeDesc">
              <div style="display: flex;justify-content: space-between;">
                <div v-if="tops.defectQuantityList.length > 0" style="flex: 1;display:flex;flex-wrap:wrap;justify-content:flex-start;align-items:center;">
                  <div v-for="(items, i) in tops.defectQuantityList" :key="i" style="width:30%;">
                    <div style="display: flex;align-items:center;justify-content: space-between;margin-bottom:10px;margin-right: 100px;">
                      <div style="flex: 1;text-align: right;padding-right: 8px;">{{ items.defectDesc }}</div>
                      <div>{{ items.quantity }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_quality_management_product_inspection_product_details',
  components: {},
  data() {
    return {
      show: false,
      defectTab: [],
      tabsActive: '',
      defectCodeDTOListName: [],
      columns: [
        {
          label: 'jianyanjieguo',
          prop: 'result',
          type: 'slot'
        },
        {
          label: 'gongxu',
          prop: 'inspectionStandardDetail.procedure',
          width: 130
        },
        {
          label: this.$t('jianyanleibie'),
          prop: 'inspectionStandardDetail.category',
          sortable: true,
          with: 130
        },
        {
          label: 'jianyanxiangmu',
          prop: 'inspectionStandardDetail.item',
          width: 180
        },
        {
          label: 'jianyangongju',
          prop: 'inspectionStandardDetail.tool',
          width: 130
        },
        {
          label: 'jianyanbiaoshi',
          type: 'slot',
          width: 180
        },
        {
          label: 'jianyanfangshi',
          prop: 'inspectionMethod.name',
          width: 180
        },
        {
          label: 'shifoubijian',
          prop: 'inspectionStandardDetail.necessity',
          type: 'bool',
          iln18: ['shi', 'fou']
        },
        {
          label: 'jianyanyiju',
          prop: 'inspectionStandardDetail.basis',
          width: 180
        },
        {
          label: 'quexiandengji',
          prop: 'inspectionStandardDetail.defectLevel',
          width: 180
        },
        {
          label: 'chouyangguocheng',
          // prop: 'samplingProcedureId',
          type: 'slot',
          width: 180
        },
        {
          label: 'yangbenshu',
          prop: 'samplingNum',
          width: 180
        },
        {
          label: 'guigexiaxian',
          prop: 'inspectionStandardDetail.specMin',
          width: 180
        },
        {
          label: 'guigeshangxian',
          prop: 'inspectionStandardDetail.specMax',
          width: 180
        },
        {
          label: 'jiliangdanwei',
          prop: 'inspectionStandardDetail.unit',
          width: 180
        },
        {
          label: 'celiangzhi',
          type: 'slot',
          // prop: 'measureJson',
          width: 180
        },
        {
          label: 'buliangpinshu',
          type: 'slot',
          width: 180
        },
        {
          label: 'tupian',
          type: 'slot',
          width: 280,
          prop: 'repairByObject.nickname'
        },
        {
          label: 'beizhu',
          prop: 'remark',
          width: 180
        }
      ]
    };
  },

  computed: {
    //不良明细
    badAccumulate() {
      let total = 0;
      if (this.defectTab.length > 0) {
        for (let i = 0; i < this.defectTab.length; i++) {
          let all = this.defectTab[i]['defectQuantityList'];
          if (all.length > 0) {
            for (let j = 0; j < all.length; j++) {
              if (all[j].quantity !== null && all[j].quantity !== undefined) {
                total += all[j].quantity;
              }
            }
          }
        }
      }
      return total;
    }
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        inspectionRecordId: this.$attrs.detailsItem.id
      };
      this.yt.get(1);
    }, 300);
  },

  methods: {
    newNumbers(array, index) {
      const obj = array.reduce((acc, val, index) => {
        const key = `样本${index + 1}`;
        acc[key] = val;
        return acc;
      }, {});

      // 将对象转换为字符串形式
      const str = Object.entries(obj)
        .map(([key, value]) => {
          return `${key}: ${value}` + '<br>';
        })
        .join('');

      return str;
    },
    //不良明细
    getDefectTypeAndCode() {
      this.http
        .get('/web/quality/inspection/record/details/defect/item/getDefectResult', {
          params: {
            inspectionRecordDetailId: this.yt.editObj.id
          }
        })
        .then(res => {
          this.defectTab = res.data || [];
          if (!this.defectTab.length == '') {
            this.tabsActive = this.defectTab[0]['levelOneDefectTypeDesc'];
          }
        });
    }
  }
};
</script>
